import { DialogTitle } from "@repo/ui/components/ui/dialog";
import { cn } from "@repo/ui/lib/utils";
import { useScheduleSessionsContext } from "./use-schedule-sessions-context";

/** Two-line session context with overall scheduling progress alongside it. */
export function ScheduleSessionsHeader() {
  const { state } = useScheduleSessionsContext();
  const { sessions, mode, practitionerName, assignedCount, allAssigned, activeSession, activeIdx } = state;
  const reviewing = mode === "review";
  const title = reviewing ? "Review your schedule" : (activeSession?.sessionTitle ?? "Schedule sessions");

  return (
    <div className="flex shrink-0 items-center justify-between gap-6 border-b py-3 pl-5 pr-14">
      <div className="min-w-0 flex-1 space-y-1">
        <DialogTitle className="truncate text-[15px] font-semibold leading-5 tracking-tight" title={title}>
          {title}
        </DialogTitle>
        <p className="truncate text-xs text-muted-foreground">
          {reviewing
            ? `${sessions.length} session${sessions.length !== 1 ? "s" : ""}`
            : `Session ${activeIdx + 1} of ${sessions.length}`}
          {!reviewing && activeSession?.duration != null ? ` · ${activeSession.duration} min` : ""}
          {practitionerName ? ` · ${practitionerName}` : ""}
        </p>
      </div>
      {!reviewing && (
        <div className="w-36 shrink-0 space-y-2">
          <p className="text-xs text-muted-foreground">
            <span className="font-medium text-foreground tabular-nums">
              {assignedCount} of {sessions.length}
            </span>{" "}
            times selected
          </p>
          <progress
            aria-label="Session times selected"
            value={assignedCount}
            max={Math.max(sessions.length, 1)}
            className={cn(
              "block h-1 w-full overflow-hidden rounded-full bg-muted [&::-webkit-progress-bar]:bg-muted [&::-webkit-progress-value]:rounded-full",
              allAssigned
                ? "[&::-webkit-progress-value]:bg-success [&::-moz-progress-bar]:bg-success"
                : "[&::-webkit-progress-value]:bg-primary [&::-moz-progress-bar]:bg-primary",
            )}
          />
        </div>
      )}
    </div>
  );
}
